import * as React from 'react';
import { connect } from 'react-redux';
import PageComponent from 'src/components/responses/PageComponent';
import { getModulePreview, getSurveyResponse, unmountPreviewResponse, getSurveyResponseOffline, saveModuleResponse } from 'src/actions/action.module';
import { setLoaderVisibility } from 'src/actions/action.common';
import { getCurrentUrl } from 'src/effects/utils/common';
import { ModuleWrapper } from 'src/styles/modules';
import PdfIcon from '@material-ui/icons/PictureAsPdf';
import { Grid, Typography, Link as MaterialLink } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import IconBackButton from '@material-ui/icons/KeyboardBackspace';
import { Button } from '@material-ui/core';
import { ModulePreviewWrapper } from '../styles/module.preview';
import { ApplicationMain } from '../styles/common';
import LoaderComponent from 'src/components/common/loader.component';
import { getLocalStorageValue, setLocalStorageValue } from 'src/effects/utils/local-storage';
import { UserType } from 'src/constants/Enum/UserType';
import * as PropTypes from 'prop-types';
import { downloadModulePdf, downloadModulePdfFn, downloadModulePdfSp } from 'src/effects/api/api.report';
import { DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY, DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY } from 'src/constants/constants';
import { PDFExport } from '@progress/kendo-react-pdf';
import { QuestionType } from '../constants/Enum/ModuleEnum';

class ModulePreviewContainer extends React.Component<any, any> {
    static contextTypes = {
        router: PropTypes.object
    }
    pdfExportComponent: any;
    state = {
        pages: [],
        response: {},
        currentPageNumber: 1,
        isPageChanged: true,
        totalPages: 0,
        moduleId: 0,
        countryModuleSurveyMappingId: 0,
        isResponsePage: false,
        deeplinkQuestionId: '',
        isDeeplinkApplicable: false,
        isOfflineMode: false,
        show: false,
        currentPageURL: '',
        moduleName: ''
    };

    constructor(props: any) {
        super(props);

        this.updateQuestion = this.updateQuestion.bind(this);
        this.updateQuestionVisibility = this.updateQuestionVisibility.bind(this);
        this.onPageClicked = this.onPageClicked.bind(this);
        this.FetchNextPage = this.FetchNextPage.bind(this);
        this.FetchPreviousPage = this.FetchPreviousPage.bind(this);
        this.goToQuestion = this.goToQuestion.bind(this);
        this.back = this.back.bind(this);
        this.addQuestionComment = this.addQuestionComment.bind(this);
        this.loaderVisibility = this.loaderVisibility.bind(this);

    }

    loaderVisibility(data: any) {
        this.props.loaderVisibility(data);
    }

    handleDownloadModulePdf(moduleId: any) {
        downloadModulePdf(moduleId);
    }

    handleDownloadModuleFrenchPdf(moduleId: any) {
        downloadModulePdfFn(moduleId);
    }

    handleDownloadModuleSpanishPdf(moduleId: any) {
        downloadModulePdfSp(moduleId);
    }

    goToQuestion(data: any) {
        this.setState({ deeplinkQuestionId: '', currentPageNumber: data.pageIndex + 1, isDeeplinkApplicable: false });
        setTimeout(() => {
            const elmnt = document.getElementById((data.pageIndex + 1) + '_' + data.clusterIndex + '_' + data.questionIndex);
            if (elmnt) {
                elmnt.scrollIntoView(false);
            }
        }, 10);
    }

    goToQuestionComment(pageNumber: any, questionId: any) {
        const pages = this.state.pages;
        const page: any = pages[this.state.currentPageNumber - 1];
        const clusters = page.page.question_clusters;

        for (let clusterIndex = 0; clusterIndex < clusters.length; clusterIndex++) {
            for (let questionIndex = 0; questionIndex < clusters[clusterIndex].questions.length; questionIndex++) {
                if (clusters[clusterIndex].questions[questionIndex].question_id === questionId) {

                    setTimeout(() => {
                        const elmnt = document.getElementById(pageNumber + '_' + clusterIndex + '_' + questionIndex);
                        if (elmnt) {
                            elmnt.scrollIntoView(false);
                        }
                    }, 10);

                    break;
                }
            }
        }
    }

    componentDidMount() {
        getCurrentUrl().then((currUrl: any) => {
            const splitUrl = currUrl.split("/");
            let countryModuleSurveyMappingId;
            let moduleId;
            let currentPageNumber = 1;
            let deeplinkQuestionId = '';
            this.state.currentPageURL = currUrl;

            const isResponsePage = currUrl.indexOf('response') > -1;
            if (isResponsePage) {
                if (splitUrl && splitUrl.length === 6) {
                    countryModuleSurveyMappingId = parseInt(splitUrl[splitUrl.length - 1], 10);
                }
                if (splitUrl && splitUrl.length === 8) {
                    countryModuleSurveyMappingId = parseInt(splitUrl[splitUrl.length - 3], 10);
                    currentPageNumber = parseInt(splitUrl[splitUrl.length - 2], 10);
                    deeplinkQuestionId = splitUrl[splitUrl.length - 1];
                    this.state.isDeeplinkApplicable = true;
                }
            }
            else {
                moduleId = parseInt(splitUrl[splitUrl.length - 1], 10);
            }

            this.setState({ countryModuleSurveyMappingId, isResponsePage, currentPageNumber, deeplinkQuestionId });

            if (isResponsePage) {
                this.getSurveyResponse(countryModuleSurveyMappingId);
            }
            else {
                this.props.getModulePreview({
                    moduleId
                });
            }
        });

        const loggedInUser = getLocalStorageValue('user');
        const isOfflineMode = getLocalStorageValue(`UserId_${loggedInUser.id}_${DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY}`);
        if (isOfflineMode === true) {
            this.setState({ isOfflineMode: true });
        }
    }

    componentDidUpdate(props: any) {
        getCurrentUrl().then((currUrl: any) => {
            const splitUrl = currUrl.split("/");
            let countryModuleSurveyMappingId;
            let currentPageNumber = 1;
            let deeplinkQuestionId = '';

            const isResponsePage = currUrl.indexOf('response') > -1;

            if (isResponsePage && this.state.isDeeplinkApplicable) {
                if (splitUrl && splitUrl.length === 8) {
                    currentPageNumber = parseInt(splitUrl[splitUrl.length - 2], 10);
                    countryModuleSurveyMappingId = parseInt(splitUrl[splitUrl.length - 3], 10);
                    deeplinkQuestionId = splitUrl[splitUrl.length - 1];

                    if (currentPageNumber !== this.state.currentPageNumber || deeplinkQuestionId !== this.state.deeplinkQuestionId || countryModuleSurveyMappingId !== this.state.countryModuleSurveyMappingId) {
                        this.setState({ countryModuleSurveyMappingId, isResponsePage, currentPageNumber, deeplinkQuestionId });
                        this.getSurveyResponse(countryModuleSurveyMappingId);
                    }
                }
            }
            else {
                this.state.isDeeplinkApplicable = true;
            }
        });
    }

    getSurveyResponse(countryModuleSurveyMappingId: any) {
        const loggedInUser = getLocalStorageValue('user');
        const isOfflineMode = getLocalStorageValue(`UserId_${loggedInUser.id}_${DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY}`);
        const roleId = loggedInUser.roleId;

        if (isOfflineMode === true && roleId === UserType.DataCollector) {
            this.props.getSurveyResponseOffline({
                countryModuleSurveyMappingId
            });
        }
        else {
            this.props.getSurveyResponse({
                countryModuleSurveyMappingId
            });
        }
    }

    onPageClicked(pageNumber: any) {
        this.setState({ currentPageNumber: pageNumber });
        if (this.state.isResponsePage && this.state.deeplinkQuestionId) {
            this.context.router.history.push(`/survey/response/${this.state.countryModuleSurveyMappingId}`);
        }
    }

    FetchNextPage() {
        if (this.state.currentPageNumber + 1 <= this.state.totalPages) {
            this.setState({ currentPageNumber: this.state.currentPageNumber + 1 });
            if (this.state.isResponsePage && this.state.deeplinkQuestionId) {
                this.context.router.history.push(`/survey/response/${this.state.countryModuleSurveyMappingId}`);
            }
        }
    }

    FetchPreviousPage() {
        if (this.state.currentPageNumber - 1 > 0) {
            this.setState({ currentPageNumber: this.state.currentPageNumber - 1 });
            if (this.state.isResponsePage && this.state.deeplinkQuestionId) {
                this.context.router.history.push(`/survey/response/${this.state.countryModuleSurveyMappingId}`);
            }
        }
    }

    updateQuestionResponseApi(question: any) {
        if (this.state.isResponsePage) {
            const localStorageuserData = getLocalStorageValue('user');
            const userId = localStorageuserData.id;

            const questionData = {
                country_module_survey_mapping_id: this.state.countryModuleSurveyMappingId,
                question_type: question.input_type,
                user_id: userId,
                question_id: question.id,
                question_responses: question.question_responses,
                question_admin_responses: question.question_admin_responses
            }           
            if (questionData.question_id > 0 && questionData.country_module_survey_mapping_id > 0) {
                this.props.saveModuleResponse(questionData);
            }
        }
    }

    addQuestionComment(addQuestionComment: any) {
        if (this.state.isResponsePage) {
            const pages = this.state.pages;
            const page: any = pages[this.state.currentPageNumber - 1];
            const clusters = page.page.question_clusters;
            const cluster = clusters[addQuestionComment.clusterIndex];
            const question = cluster.questions[addQuestionComment.questionIndex];
            const comments = question.question_comments;
            if (comments && addQuestionComment.comment) {
                switch (comments.length) {
                    case 0:
                        {
                            question.question_comments.push(addQuestionComment.comment)
                            question.question_comments_count = parseInt(question.question_comments_count, 10) + 1;
                        }
                        break;
                    case 1:
                    case 2:
                        {
                            const oldComment = JSON.parse(JSON.stringify(comments[0]));
                            question.question_comments = [];
                            question.question_comments.push(addQuestionComment.comment);
                            question.question_comments.push(oldComment);
                            question.question_comments_count = parseInt(question.question_comments_count, 10) + 1;
                        }
                        break;
                }

                if (this.state.isPageChanged) {
                    this.setState({
                        pages,
                        isPageChanged: false
                    })
                }
            }
        }

    }

    updateQuestion(questionData: any, isVisibleDepend?: boolean) {
        const pages = this.state.pages;
        // const page: any = pages[this.state.currentPageNumber - 1];
        const page: any = pages[questionData.pageIndex];
        const clusters = page.page.question_clusters;
        const cluster = clusters[questionData.clusterIndex];
        const question = cluster.questions[questionData.questionIndex];
        const questionResponse = questionData.classType && question.question_responses[questionData.classType - 1];
        let isAnswerUpdated = false;
        const loggedInUser = getLocalStorageValue('user');
        const isOfflineMode = getLocalStorageValue(`UserId_${loggedInUser.id}_${DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY}`);
        const userId = loggedInUser.id;
        if (question.input_type === QuestionType.AdminLevel && this.state.isResponsePage) {
            isAnswerUpdated = true;
            if (isOfflineMode) {
                question.is_response_offline_filled = true;
            }
        }
        else if (question.input_type !== 6) {
            if ((questionResponse.value !== questionData.response.value
                || questionResponse.unavailable !== questionData.response.unavailable
                || questionResponse.other_text !== questionData.response.other_text)) {
                questionResponse.value = questionData.response.value;
                questionResponse.unavailable = questionData.response.unavailable ? questionData.response.unavailable : false;
                questionResponse.other_text = questionData.response.other_text;
                isAnswerUpdated = true;
                if (isOfflineMode) {
                    question.is_response_offline_filled = true;
                }
            }
        } else if (question.input_type === 6 && isVisibleDepend) {
            isAnswerUpdated = true;
            questionResponse.value = questionData.response.value;
            if (isOfflineMode) {
                question.is_response_offline_filled = true;
            }
        }
        else {
            const currentAnswerString = JSON.stringify(questionResponse.value);
            const updatedAnswerString = JSON.stringify(questionData.response.value);
            const updatedAnswerJSON = JSON.parse(updatedAnswerString);
            if (questionResponse.other_text !== questionData.response.other_text || currentAnswerString !== updatedAnswerString) {
                questionResponse.value = updatedAnswerJSON;
                questionResponse.other_text = questionData.response.other_text;
                if (isOfflineMode) {
                    question.is_response_offline_filled = true;
                }
                isAnswerUpdated = true;
            }
        }

        if (isAnswerUpdated) {
            // Updating responses in localstorage for offline mode
            if (isOfflineMode === true) {
                const moduleResponse = getLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}_${this.state.countryModuleSurveyMappingId}`);
                if (moduleResponse) {
                    moduleResponse.data.payload.module_pages = pages;
                    setLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}_${this.state.countryModuleSurveyMappingId}`, JSON.stringify(moduleResponse));
                }
            }
            else {
                let isUpdate = true;
                if (question.input_type === QuestionType.AdminLevel && question.question_admin_responses && question.question_admin_responses.length === 0) {
                    isUpdate = false;
                }

                if (isUpdate) {
                    this.updateQuestionResponseApi(question);
                }
            }

            this.setState({
                pages,
                isPageChanged: false
            })
        }

    }

    updateQuestionVisibility(updateQuestionVisibilityData: any) {
        const pages = this.state.pages;
        const page: any = pages[updateQuestionVisibilityData.pageIndex];
        const clusters = page.page.question_clusters;
        const cluster = clusters[updateQuestionVisibilityData.clusterIndex];
        const question = cluster.questions[updateQuestionVisibilityData.questionIndex];
        let isDefaultValueSet: boolean = false;
        if (question.is_visible !== updateQuestionVisibilityData.isVisible) {
            if (!question.is_visible) {
                if ((Array.isArray(question.question_responses) && question.question_responses.length > 0) && this.state.isResponsePage &&
                    (Array.isArray(question.default_question_responses) && question.default_question_responses.length > 0)) {
                    if (question.question_responses.length === question.default_question_responses.length) {
                        question.question_responses.forEach((questionRespnse: any, index: number) => {
                            if ((questionRespnse.value === '' && question.default_question_responses[index].value !== '') || (question.input_type === QuestionType.Checkbox && Array.isArray(questionRespnse.value) && question.default_question_responses[index].value !== '')) {
                                if (this.props.response.survey_type === 2) {
                                    questionRespnse.value = question.default_question_responses[index].value;
                                    isDefaultValueSet = true;
                                }
                            }
                        })
                    }
                }
            }

            question.is_visible = updateQuestionVisibilityData.isVisible;
            const visibleQuestions = cluster.questions.filter((ques: any) => {
                return ques.is_visible === true;
            });

            cluster.is_hidden = false;
            if (visibleQuestions.length === 0) {
                cluster.is_hidden = true;
            }

            if (isDefaultValueSet && this.state.isOfflineMode) {
                question.is_response_offline_filled = true;
                const loggedInUser = getLocalStorageValue('user');
                const userId = loggedInUser.id;
                const moduleResponse = getLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}_${this.state.countryModuleSurveyMappingId}`);
                if (moduleResponse) {
                    moduleResponse.data.payload.module_pages = pages;
                    setLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}_${this.state.countryModuleSurveyMappingId}`, JSON.stringify(moduleResponse));
                }
            }

            this.setState({
                pages,
                isPageChanged: false
            }, () => {
                if (question.input_type === QuestionType.AdminLevel && question.question_admin_responses && question.question_admin_responses.length === 0) {
                    isDefaultValueSet = false;
                }

                if (isDefaultValueSet && !this.state.isOfflineMode) {
                    this.updateQuestionResponseApi(question)
                }
            })
        }
    }

    componentWillReceiveProps(props: any) {
        if (props && props.response && props.response.module_pages) {
            if (this.state.deeplinkQuestionId) {
                this.setState({
                    response: props.response,
                    pages: props.response.module_pages,
                    isPageChanged: true,
                    totalPages: props.response.module_pages.length
                },
                    () => {
                        this.goToQuestionComment(this.state.currentPageNumber, this.state.deeplinkQuestionId);
                    })
            }
            else {
                this.setState({
                    response: props.response,
                    pages: props.response.module_pages,
                    isPageChanged: true,
                    totalPages: props.response.module_pages.length
                })
            }
        }
    }

    back() {
        const localStorageuserData = getLocalStorageValue('user')
        switch (localStorageuserData.roleId) {
            case UserType.HQAdmin:
            case UserType.DataManager:
                if (this.state.isResponsePage && localStorageuserData) {
                    this.props.history.push('/hq-admin-survey-response/' + this.props.response.survey_id);
                }
                else {
                    this.props.history.push('/modules');
                }
                break;

            case UserType.DataManagerSupply:
                if (this.state.isResponsePage && localStorageuserData) {
                    this.props.history.push('/hq-admin-survey-response/' + this.props.response.survey_id);
                }
                else {
                    this.props.history.push('/modules');
                }
                break;
            case UserType.DataManagerRegional:
            case UserType.DataManagerSupplyRegional:
            case UserType.RegionalAdmin:
                if (this.state.isResponsePage && localStorageuserData) {
                    this.props.history.push('/regional-admin-survey-response/' + this.props.response.survey_id);
                }
                else {
                    this.props.history.push('/modules');
                }
                break;
            case UserType.DataCollector:
                if (this.state.isResponsePage && localStorageuserData) {
                    this.props.history.push('/Data-Collector-survey-response/' + this.props.response.survey_id);
                }
                break;
        }
    }

    componentWillUnmount() {
        this.props.unmountPreviewResponse(null);
    }

    exportSummaryPageAsPDF = () => {
        this.pdfExportComponent.save();
    }
    render() {
        let pageDataState: any;
        let pagePreview: any;
        const response: any = this.state.response;
        if (this.state.pages && this.state.pages.length > 0) {
            pageDataState = this.state.pages[this.state.currentPageNumber - 1];
            pagePreview = pageDataState && pageDataState.page;
        }

        return (
            <ApplicationMain>
                <LoaderComponent sending={this.props.show} />

                <ModulePreviewWrapper>

                    <div className="pageContainer previewScreen" >
                        <PDFExport
                            paperSize="A3"
                            margin="1cm"
                            ref={(component) => this.pdfExportComponent = component
                            }
                        >
                            <div className="pageHeading">
                                <Grid container={true} spacing={8}>
                                    <Grid item={true} xs={9}>
                                        <div className="pageTitleSection">
                                            <IconButton onClick={this.back} className="backButton" color="inherit" aria-label="Open drawer">
                                                <IconBackButton />
                                            </IconButton>
                                            <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                                {response ? response.module_name : ''}
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid item={true} xs={3} className="text-right">
                                        {
                                            this.state.isResponsePage ?
                                                <b>Country: {response ? response.country_name : ''}</b>
                                                :
                                                ''
                                        }
                                    </Grid>
                                </Grid>

                                <Grid container={true} spacing={8}>
                                    <Grid item={true} xs={6}>

                                        <div className="pagePagination">
                                            {
                                                this.state.pages && pagePreview && pagePreview.question_clusters &&
                                                <ul className="pagination">
                                                    <li className="page-item">Pages: </li>
                                                    {
                                                        this.state.pages.map((page: any, key: any) => {
                                                            return <li key={page.page_number} className="page-item" onClick={this.onPageClicked.bind(this, page.page_number)}><a className={page.page_number === this.state.currentPageNumber ? 'page-link active' : 'page-link'} href="javascript:void(0)"	>{page.page_number}</a></li>;
                                                        })
                                                    }

                                                </ul>
                                            }
                                        </div>
                                    </Grid>


                                    <Grid item={true} xs={3} className="text-right">
                                        {
                                            !this.state.isOfflineMode
                                                ?
                                                <Typography>
                                                    <IconButton className="menuButton" color="inherit" aria-label="Open drawer">
                                                        <PdfIcon />
                                                    </IconButton> Download PDF
                                            </Typography>
                                                : ''
                                        }
                                    </Grid>

                                    <Grid item={true} xs={1} className="text-right">
                                        {
                                            !this.state.isOfflineMode
                                                ?
                                                <Typography>
                                                    <MaterialLink onClick={this.handleDownloadModulePdf.bind(this, response.module_id)} className="pageLink">
                                                        <IconButton className="menuButton" color="inherit" aria-label="Open drawer">English </IconButton>
                                                    </MaterialLink>
                                                </Typography>
                                                : ''
                                        }
                                    </Grid>
                                    {
                                        <Grid item={true} xs={1} className="text-right">
                                            {
                                                !this.state.isOfflineMode
                                                    ?
                                                    <Typography>
                                                        <MaterialLink onClick={this.handleDownloadModuleFrenchPdf.bind(this, response.module_id)} className="pageLink">
                                                            <IconButton className="menuButton" color="inherit" aria-label="Open drawer">Français </IconButton>
                                                        </MaterialLink>
                                                    </Typography>
                                                    : ''
                                            }
                                        </Grid>
                                    }

                                    <Grid item={true} xs={1} className="text-right">
                                        {
                                            !this.state.isOfflineMode
                                                ?
                                                <Typography>
                                                    <MaterialLink onClick={this.handleDownloadModuleSpanishPdf.bind(this, response.module_id)} className="pageLink">
                                                        <IconButton className="menuButton" color="inherit" aria-label="Open drawer">Español </IconButton>
                                                    </MaterialLink>
                                                </Typography>
                                                : ''
                                        }
                                    </Grid>

                                </Grid>
                            </div>
                            <div className="pageContent" id="MainDiv">

                                {
                                    this.state.pages && pagePreview && pagePreview.question_clusters &&
                                    <ModuleWrapper>
                                        <div className="contentSection">
                                            <Grid container={true} spacing={24}>
                                                <Grid item={true} xs={12}>
                                                    <PageComponent
                                                        updateQuestionVisibility={this.updateQuestionVisibility}
                                                        goToQuestion={this.goToQuestion}
                                                        pages={this.state.pages}
                                                        updateQuestion={this.updateQuestion}
                                                        clusters={pagePreview.question_clusters}
                                                        pagePreview={pagePreview}
                                                        addQuestionComment={this.addQuestionComment}
                                                        countryModuleSurveyMappingId={this.state.countryModuleSurveyMappingId}
                                                        surveyStatus={response.survey_status}
                                                        surveyId={response.survey_id}
                                                        surveyType={response.survey_type}
                                                        moduleId={response.module_id}
                                                        isResponsePage={this.state.isResponsePage}
                                                        loaderVisibility={this.loaderVisibility}
                                                        isOfflineMode={this.state.isOfflineMode}
                                                        moduleName={response.module_name}
                                                        isShowRecentData={response.is_show_recent_data}
                                                    />
                                                </Grid>
                                            </Grid>
                                            {
                                                <footer className="footerSection">
                                                    <div className="alignLeft">
                                                        {
                                                            this.state.currentPageNumber - 1 > 0 &&
                                                            <Button type="button" className="btn-blue" onClick={this.FetchPreviousPage} variant="outlined" size="medium">
                                                                Previous Page
                                            </Button>
                                                        }

                                                        {
                                                            this.state.currentPageNumber - 1 < 0 &&
                                                            <Button type="button" className="btn-blue" disabled={this.state.currentPageNumber - 1 <= 0} variant="outlined" size="medium">
                                                                Previous Page
                                            </Button>
                                                        }
                                                    </div>
                                                    <div className="grow" />

                                                    <div className="alignRight">
                                                        {
                                                            this.state.currentPageNumber + 1 <= this.state.totalPages &&
                                                            <Button type="button" className="btn-blue" onClick={this.FetchNextPage} variant="outlined" size="medium">
                                                                Go to Next Page
                                                    </Button>
                                                        }


                                                        {
                                                            this.state.currentPageNumber + 1 > this.state.totalPages &&
                                                            <Button type="button" className="btn-blue" disabled={this.state.currentPageNumber + 1 > this.state.totalPages} variant="outlined" size="medium">
                                                                Go to Next Page
                                                    </Button>
                                                        }
                                                        {
                                                            /* <Button type="button" className="btn-blue" onClick={this.exportSummaryPageAsPDF} variant="outlined" size="medium">
                                                             Download PDF
                                                     </Button> */
                                                        }

                                                    </div>

                                                </footer>
                                            }
                                        </div>



                                    </ModuleWrapper>
                                }

                                {
                                    pagePreview === undefined &&

                                    <Grid container={true} spacing={24}>
                                        <Grid item={true} xs={4} />
                                        <Grid item={true} xs={4}>
                                            <h1>No Preview Available</h1>
                                        </Grid>
                                        <Grid item={true} xs={4} />
                                    </Grid>
                                }
                            </div>
                        </PDFExport>
                    </div>
                </ModulePreviewWrapper>
            </ApplicationMain>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        show: state.common.show,
        response: state.model.response
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        getModulePreview: (data: any) => dispatch(getModulePreview(data)),
        getSurveyResponse: (data: any) => dispatch(getSurveyResponse(data)),
        getSurveyResponseOffline: (data: any) => dispatch(getSurveyResponseOffline(data)),
        unmountPreviewResponse: (data: any) => dispatch(unmountPreviewResponse(data)),
        loaderVisibility: (data: any) => dispatch(setLoaderVisibility(data)),
        saveModuleResponse: (data: any) => dispatch(saveModuleResponse(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModulePreviewContainer);




// WEBPACK FOOTER //
// ./src/containers/ModulePreviewContainer.tsx